/*
  1. 定义这个组件的目的是，检查某些操作是否具备合法性。比如喜欢、收藏、关注等功能都必须是要求用户登录后才能进行的操作。
  2. 注意，这个检查不和服务器进行交互的，只是从客户端缓存的状态来检查是否授权。这样设计的目的是，可以极大的减少与服务器之间的交互。
*/
import {vue} from "./main";
import {getCachedUser, infoMessage, showLoginComponent} from "./utils";


export class CachedApiSecurity{

    /**
     * 这是从前端缓存去判断用户是否已经登录了，注意不合服务器进行任何的交互
     * @return {boolean}
     */
    static isSignedIn(){
        return getCachedUser() === null ? false : true;
    }

    /**
     *  1. 提示需要登录
     *  2. 显示登录框
     */
    static handleNoAuthorith(){
        if(!CachedApiSecurity.isSignedIn()){
            vue.$confirm('该操作需要登录以后才能操作，是否登录？', '提示', {
                confirmButtonText: '确定',
                confirmButtonClass: 'el-button--danger',
                cancelButtonText: '取消',
                cancelButtonClass: 'el-button--default',
                type: 'info',
                center: true,

            }).then(() => {
                setTimeout(()=>{
                    showLoginComponent();
                }, 300)
            }).catch(() => {
                console.log('user cancelled to login');
            });
        }
    }

}




// WEBPACK FOOTER //
// ./src/api-security.js